import Collapsible from './collapsible';
import './collapsible.scss';

export default Collapsible;
